export default __webpack_public_path__ + "static/media/house.71b7d514.png";